export default {
  brewery: 'PerennialSociete',
  info_url: 'http://landing.tavour.com/PerenialSociete/',
  title: {
    in_progress: '',
    success: 'You Joined Perennial Artisan Ales Société du Chêne! ',
    subtext: 'Join Perennial Artisan Ales Société du Chêne and unlock a year of rare barrel-aged beers. ',
    sub_subtext: 'This membership brings a curated mix of exclusive favorites, ' +
      'delivered right to your door. Twice a year, we’ll send you six bottles of rare barrel aged beers, ' +
      'shipped in the winter and the summer for $295 per release (shipping included). ' +
      'Experience our award winning spirits barrel aged program - including stouts, barleywines and wheatwines - ' +
      'without the trip to St. Louis. ' +
      'We can\'t wait to share them with you!',
  },
  review: {
    summary: [
      'You are joining Perennial Artisan Ales Société du Chêne. ',
      'By signing up your card will be charged for $295 per release (shipping included). ' +
      'Twice a year, we’ll send you six bottles of rare barrel aged beers, ' +
      'shipped in the winter and the summer. ',
      'You will have the option to opt out by emailing support@tavour.com. ' +
      'You will receive a notification when your box has been charged and shipped. ',
      'In addition to the twice a year shipments, Société du Chêne members will also receive exclusive ' +
      'access to cellar sales and limited release beers not offered through the traditional Tavour program, ' +
      'as well as a 15% on-premise discount at the brewery.',
    ],
    button_text: 'Join the Société du Chêne!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/perennialSociete.js